import axios from "axios"
import { showSuccess, showError, showWarning } from "../utils/helper/toastHelper";

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_TRACKER_API_BASE_URL,
  timeout: 30000,
});

apiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) config.headers.Authorization = `${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(function onFulfilled(response) {
  const { config, data } = response;
  // Avoid success toast in GET methods
    if (config.method !== "get" && config.successToast) {
      const message =
        typeof config.successToast === "string"
          ? config.successToast
          : data?.message || "Operation completed successfully";

      showSuccess(message);
    }

    return response;

}, function onRejected(error) {
    if(!error.response){
      if(error.code === "ECONNABORTED"){
        showError("Request timeout exceeded");

      }else{
        showError("Network error. Please check your connection.");

      }
      return Promise.reject(error);
    }

    const { status, data } = error.response;
    const message =
      data?.message ||
      data?.error ||
      "An unexpected error occurred";
     
    switch (status) {
      case 400:
        showWarning(message);
        break;

      case 401:
        showError("Invalid or missing API access key.");
        break;

      case 403:
        showError("You do not have permission to perform this action.");
        break;

      case 404:
        showWarning("Requested resource not found.");
        break;

      case 409:
        showWarning(message);
        break;

      case 422:
        showWarning(message);
        break;

      case 500:
        showError("Internal server error. Please try again later.");
        break;

      default:
        showError(message);
        break;
    }

    return Promise.reject(error);
})

export default apiClient;